import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

const Navbar = ({ title, backTo, children }) => {
  const { user, logout } = useAuth();
  const { darkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();

  return (
    <nav className="bg-navy-700 dark:bg-dark-300 text-white px-6 py-4 shadow-lg">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-4">
          {backTo && (
            <button
              onClick={() => navigate(backTo)}
              className="text-cream-200 hover:text-white transition-colors text-sm"
            >
              ← Tilbake
            </button>
          )}
          <div>
            <span className="text-gold-500 font-bold text-xl tracking-wide">PODIUM</span>
            {title && <span className="text-cream-200 ml-3 text-sm font-medium">{title}</span>}
          </div>
        </div>

        <div className="flex items-center gap-4">
          {children}
          <button
            onClick={toggleTheme}
            className="text-cream-200 hover:text-white transition-colors text-lg"
            title={darkMode ? 'Lyst tema' : 'Mørkt tema'}
          >
            {darkMode ? '☀️' : '🌙'}
          </button>
          {user && (
            <div className="flex items-center gap-3">
              <span className="text-cream-200 text-sm hidden md:block">{user.name}</span>
              <button
                onClick={logout}
                className="text-sm text-cream-200 hover:text-white border border-cream-200 hover:border-white px-3 py-1 rounded-lg transition-all"
              >
                Logg ut
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
